import { useParams } from "react-router-dom";
import { getToken } from "../../utils/utils";
import { JSXElementConstructor, Key, ReactElement, ReactNode, ReactPortal, useEffect, useState } from "react";
import { approvaldurations } from "./api";
import { Box, Button, InputAdornment, List, ListItem, TextField, Typography } from "@mui/material";
import CreateCohort from "../../components/AssignTask/CreateCohort";
import Link from '@mui/material/Link';
import Plus from "../../../src/assests/images/Plus.svg";
import SearchIcon from "@mui/icons-material/Search";
import StepperWithPoints from "./QuestionProgress";
import QuestionCard from "./QuestionCard";
import { previewtaskapi } from "../reports/api";
import cigar from "../../../src/assests/images/calendar-circle.svg";
import banner from "../../../src/assests/images/smook-gal.png"
import arrowleft from "../../../src/assests/images/arrow_left.svg"
import coin from "../../../src/assests/images/coin.svg"
import largecoin from "../../../src/assests/images/large_coin.svg"
import PaginationComponent from "../../pages/brands/Pagination";

type Hint = {
  imgg: string;
  steps: string;
  para: string;
};

type QuestionDetail = {
  question_no: ReactNode;
  task_desc_en: string;
  question_id: number;
  question_en: string;
  sample_picture: string;
  points: number;
  hints: Hint[];
};
function Test() {
  const { task_id, task_type } = useParams();
  const token = getToken();
  const [isLoading, setIsLoading] = useState(true);
  console.log(task_id, "task_idssssssss4444444444", task_type, "task_typesssssssss")
  const [retailersData, setRetailersData] = useState<[]>([]);
  const perpagedata = 1;
  const [page, setPage] = useState(1);
  const [taskname, settaskname] = useState('');
  const [taskcredit, settaskcredit] = useState('');
  const [taskdescriptions, settaskdescriptions] = useState('');

  const [taskquestionslength, settaskquestionslength] = useState('');
  const [taskquestionslengthedu, settaskquestionslengthedu] = useState('');
  const [questionsdetails, setquestionsdetails] = useState<[]>([]);

  const [questionstab, setquestionstab] = useState<number>(1);

  const [questionsdetails1, setquestionsdetails1] = useState<number>(1);
  const [questionsdetailsmain, setquestionsdetailsmain] = useState<[]>([]);
  const [questionsdeducationsal, setquestionsdeducationsal] = useState<[]>([]);
  const [questionsdeducationsaldetailss, setquestionsdeducationsaldetailss] = useState<[]>([]);

  const [questionsdetailfinal, setquestionsdetailfinal] = useState<QuestionDetail[]>([]);


  useEffect(() => {
    if (task_id && task_type === "Availability") {
      const fetchData = async () => {
        setIsLoading(true);

        const reqBody = {
          task_id: task_id,
          task_type: task_type,
          page: page,
          limit: perpagedata
        };

        try {
          const response = await previewtaskapi(reqBody, token);
          settaskname(response.data.data.task_name)
          console.log(response.data.data, "mmmmmmmmmmmmmmmmm")
          const alldetails = response.data.data.task_question.map((item: {
            question_no: any; task_desc_en: any; question_id: any; question_en: any; sample_picture: any; points: any; hint: { hint_steps: any[]; }[];
          }) => ({
            task_desc_en: item.task_desc_en,
            question_id: item.question_id,
            question_no: item.question_no,
            question_en: item.question_en,
            sample_picture: item.sample_picture,
            points: item.points,
            hints: item.hint.flatMap((ste: { hint_steps: any[] }) =>
              ste.hint_steps.map(uu => ({
                imgg: uu.step_icon,
                steps: `Step ${uu.step_id}`,
                para: uu.step_en
              }))
            )
          }));


          setquestionsdetailfinal(alldetails)
          settaskquestionslength(response.data.data.question_lenght)
          settaskcredit(response.data.data.credit_points)
          setquestionsdetails1(response.data.data.question_lenght)
          settaskdescriptions(response.data.data.task_desc_en)


          // const mappedData = response.data.data.finaluser_tasks.map((item: any) => ({
          //   // userId: item.userId,
          //   // PMIEntityCode: item.pmi_entity_code,
          //   // retailer_name: item.retailer_name,
          //   // outlet_name: item.outlet_name,
          //   // locations: item.locations,
          //   // outlet_type: item.outlet_type,
          //   // member_Since: item.member_Since,
          //   // TotalTaskCompleted: item.no_of_task,
          //   // lastLogin: item.lastLogin,
          //   // remaining_points: item["remaining_points/total_points"].split("/")[0],
          //   // total_points: item["remaining_points/total_points"].split("/")[1],
          // }));

          // setRetailersData(mappedData);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setIsLoading(false);
        }
      };

      fetchData(); // <-- make sure to call the function here
    }
  }, [task_id, task_type, token, page, perpagedata]); // <-- also add dependencies to avoid stale values
  console.log(questionsdetailfinal, "questionsdetailfinal88999")
  useEffect(() => {
    if (task_id && task_type === "Educational") {
      const fetchData = async () => {
        setIsLoading(true);

        const reqBody = {
          task_id: task_id,
          task_type: task_type,
          page: page,
          limit: perpagedata
        };

        try {
          const response = await previewtaskapi(reqBody, token);
          console.log(response.data.data.task_name, "dddddddddddddddd")
          settaskname(response.data.data.task_name)

          settaskcredit(response.data.data.credit_points)
          settaskquestionslengthedu(response.data.data.question_lenght)
          setquestionsdeducationsal(response.data.data.task_question)

          setquestionsdeducationsaldetailss(response.data.data.taskdetails)
          console.log(response.data.data.task_question, "task_questionsssssssssss")
          setquestionsdetailsmain(response.data.data.task_question)


        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setIsLoading(false);
        }
      };

      fetchData(); // <-- make sure to call the function here
    }
  }, [task_id, task_type, token, page, perpagedata]);
  const totalPages1 = Math.ceil(Number(taskquestionslength) / perpagedata);
  const totalPages1edu = Math.ceil(Number(taskquestionslengthedu) / perpagedata);

  console.log(questionsdeducationsal, "questionsdetails9999999999999999999999")
  console.log(taskname, "tasknamessssssssssss")
  console.log(questionsdetails1, "questionsdetails7585")
  const [step, setStep] = useState(1);

  const steps = Array.from({ length: questionsdetails1 }, (_, index) => ({
    id: index + 1,
    label: `Picture ${index + 1}`,
  }));
  const handleNext = () => {
    if (step < steps.length) {
      setStep(step + 1);
    }
  };

  const more = [
    {
      imgg: banner,
      steps: "Step 1",
      para: "Take out the pack and open the lid"
    },
    {
      imgg: banner,
      steps: "Step 2",
      para: "Take out the pack and open the lid"
    },
    {
      imgg: banner,
      steps: "Step 3",
      para: "Take out the pack and open the lid"
    }
  ];

  console.log(page, "page4455566660000000")
  console.log("kkk")
  console.log(process.env.REACT_APP_API_URL, "process.env.REACT_APP_API_URLsss")
  return (
    <>
      {task_type === "Educational" && (
        <Box sx={{ width: "375px", background: "#fff", marginLeft: "auto", marginRight: "auto", marginBottom: '50px' }}>
          <Box sx={{ padding: "24px 32px 0", background: "#fff " }}>
            <Link
              href="#"
              sx={{
                textDecoration: "none",
                fontSize: "14px",
                fontWeight: "500",
                color: "rgba(105, 106, 107, 1)",
              }}
            >
              Tasks /
              <Link
                href="#"
                sx={{
                  textDecoration: "none",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "rgba(142, 2, 15, 1)",
                }}
              >
                Assign Task
              </Link>
            </Link>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#000",
                    marginTop: "16px",
                  }}
                >
                  {taskname}
                </Typography>
              </Box>

            </Box>


          </Box>
          <Box sx={{ marginTop: "30px", width: "375px" }}>
            <StepperWithPoints activeStep={page} questionstab={questionstab}
              setquestionstab={setquestionstab} questionsdetails={questionsdeducationsaldetailss} />
          </Box>

          <Box sx={{
            marginTop: "50px", justifyContent: "flex-start", display: "flex", width: "355px", marginLeft: "10px"
          }}>
            < Box sx={{

            }}>
              < QuestionCard questionsdetailsmain={questionsdetailsmain} />

            </Box >
          </Box >
          <PaginationComponent
            page={page}
            limit={1}
            totalPages={Number(totalPages1edu)}
            setPage={setPage}
          />
        </Box>

      )}

      {task_type === "Availability" && (
        <Box sx={{ maxWidth: "375px", margin: "0 auto", position: "relative", padding: "0 0 20px" }}>
          <Box sx={{ backgroundColor: "#FFF", padding: "16px" }}>
            {/* Header */}
            <Box sx={{ display: "flex", gap: "12px", justifyContent: "space-between", marginBottom: "24px" }}>
              <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
                <img height={18} width={18} src={arrowleft} alt="arrowleft" />
                <Typography sx={{ fontSize: "16px", fontWeight: "500" }} variant="h6">{taskname}</Typography>
              </Box>
              <Box sx={{ display: "flex", gap: "7px", borderRadius: "40px", backgroundColor: "#F5F6F7", border: "1px solid #E8E8E8", padding: "8px 4px" }}>
                <img src={coin} alt="coin" />
                <Typography sx={{ fontSize: "12px", fontWeight: "700" }} variant="h6">Earn {taskcredit} pts</Typography>
              </Box>
            </Box>

            {/* Progress Line */}
            {steps.some(item => item.id >= 2) && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '63px',
                  left: '51px',
                  right: '51px',
                  height: '3px',
                  backgroundColor: step >= 2 ? '#C8172F' : '#FFEBEF',
                  zIndex: 0,
                  marginTop: "24px"
                }}
              />
            )}


            {/* Step Indicators */}
            <Box sx={{ display: "flex", justifyContent: "space-between", position: "relative", zIndex: 1 }}>
              {steps.map((stepItem) => {
                const isActive = stepItem.id === page;
                const isCompleted = step > stepItem.id;
                console.log(questionsdetailfinal, "ssssssssssssssseeeeeeeeeeeee")
                return (
                  <Box key={stepItem.id} sx={{ textAlign: 'center' }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "0 auto",
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        border: "2px solid",
                        borderColor: isCompleted
                          ? "#46C65A"
                          : isActive
                            ? "#C8172F"
                            : "#C5C6C7",
                        backgroundColor: isCompleted
                          ? "#46C65A"
                          : isActive
                            ? "#FFEBEF"
                            : "#F1F1F1", // fallback color if not active or completed
                        color: isCompleted
                          ? "#ffffff"
                          : isActive
                            ? "#C8172F"
                            : "#7D7E7F",
                        fontSize: "12px",
                        fontWeight: "700",
                      }}
                    >
                      {stepItem.id}
                    </Box>
                    <Typography
                      sx={{
                        color: "#696A6B",
                        fontSize: "12px",
                        fontWeight: "400",
                        marginTop: "5px"
                      }}
                    >
                      {stepItem.label}
                    </Typography>
                  </Box>
                );
              })}

            </Box>
          </Box>

          {/* Instructions Heading */}

          {/* <Box sx={{ backgroundColor: "#FFF",borderRadius: "10px", margin: "20px 0 3px",display:"flex",alignItems:"start",justifyContent:"space-between",padding:"12px 0 0 16px",border:"1px solid rgba(250, 212, 102, 0.00)",background:"linear-gradient(110deg, rgba(255, 248, 187, 0.00) 38.52%, rgba(220, 220, 106, 0.32) 100%), #FFF",}}>
      <Box>
        <Typography variant="h6" sx={{fontSize: "12px", fontWeight: "600", color: "#7D7E7F"}}>Task</Typography>
        <Typography sx={{ fontSize: "20px", fontWeight: "600", color: "#282829" }} variant="h3">{taskdescriptions}</Typography>
      </Box>
      <Box sx={{marginBottom:"-7px",} }><img src={largecoin} alt="largecoin" /></Box>
    </Box> */}

          {/* Question Details */}
          {questionsdetailfinal.map((item, qIndex) => (
            <Box key={qIndex} sx={{ backgroundColor: "#FFF", padding: "16px", borderRadius: "16px", margin: "20px 0 3px" }}>
              {/* <Box sx={{ display: "flex", gap: "12px", justifyContent: "space-between", alignItems: "center", marginBottom: "12px", paddingBottom: "12px", borderBottom: "1px dashed #C5C6C7" }}>
          <Typography sx={{ fontSize: "14px", fontWeight: "500", color: "#696A6B" }} variant="h6">
            Picture {page}: <span style={{ fontWeight: "700", color: "#282829" }}>{item.question_en}</span>
          </Typography>
          <Box sx={{ display: "flex", gap: "7px", borderRadius: "40px", backgroundColor: "#F5F6F7", border: "1px solid #E8E8E8", padding: "8px 4px" }}>
            <img src={coin} alt="coin" />
            <Typography sx={{ fontSize: "12px", fontWeight: "700" }} variant="h6">{item.points} pts</Typography>
          </Box>
        </Box> */}

              <Typography sx={{ fontSize: "20px", fontWeight: "600", marginBottom: "16px" }} variant="h3">{item.question_en}</Typography>

              {/* Hint Steps */}
              {item.hints.map((stepItem: { imgg: string | undefined; steps: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined; para: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined; }, sIndex: Key | null | undefined) => (
                <Box key={sIndex} sx={{ display: "flex", gap: "14px", marginBottom: "12px" }}>
                  <Box sx={{ padding: "9px 14px", backgroundColor: "#FFEBEF", borderRadius: "50%", height: "56px", width: "56px" }}>
                    <img height={39} width={28} src={`${process.env.REACT_APP_API_URL}${stepItem.imgg}`} alt="Step" crossOrigin="anonymous" />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: "12px", fontWeight: "600", color: "#7D7E7F" }} variant="body1">{stepItem.steps}</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#282829", marginBottom: "3px", maxWidth: "202px", lineHeight: "20px" }} variant="subtitle2">
                      {stepItem.para}
                    </Typography>
                  </Box>
                </Box>
              ))}

              <Typography variant="subtitle1" sx={{ fontSize: "14px", color: "#282829", fontWeight: "700", borderBottom: "1px dashed #C5C6C7", marginBottom: "10px", paddingBottom: "16px" }}>
                Sample Image
              </Typography>

              {/* Sample Image & Button */}
              <Box sx={{ textAlign: "center" }}>
                <img height={100} width={100} src={`${process.env.REACT_APP_API_URL}${item.sample_picture}`} alt="banner" crossOrigin="anonymous" />
                <Button sx={{ width: "100%", borderRadius: "8px", marginTop: "10px", border: "1px solid #C8172F", backgroundColor: "#C8172F", color: "#FFF", textTransform: "capitalize" }}>
                  Take a Picture
                </Button>
              </Box>
            </Box>
          ))}

          {/* Submit Button */}
          {/* <Button
      sx={{
        width: "100%",
        borderRadius: "8px",
        marginTop: "10px",
        border: "1px solid #C8172F",
        textTransform: "capitalize"
      }}
      onClick={handleNext}
      disabled={step >= steps.length}
    >
      Submit
    </Button> */}

          {/* Pagination */}
          <PaginationComponent
            page={page}
            limit={10}
            totalPages={Number(totalPages1)}
            setPage={setPage}
          />
        </Box>
      )}





    </>
  )
}

export default Test;
